import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as TicketActions from './ticket.actions';
import * as TicketFeature from './ticket.reducer';
import * as TicketSelectors from './ticket.selectors';
import { Observable, take } from 'rxjs';
import { ICounterModel, TError } from '@amwager/util-ts';

@Injectable()
export class TicketFacade {
  private readonly store = inject(Store);

  // Selectors — expose store state as observables

  isError$(): Observable<TError> {
    return this.store.pipe(select(TicketSelectors.getTicketError));
  }

  // counters
  counter$(): Observable<ICounterModel | undefined> {
    return this.store.pipe(select(TicketSelectors.getCounters));
  }

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   *
   * Dispatches: Requests only, from WagerActionss
   */

  /**
   * Initialize the ticket state (idempotent — do not call multiple times)
   * @param {string} sourceInitiator Component that triggered init
   * @returns {void}
   */
  initState(sourceInitiator: string): void {
    this.store.select(TicketSelectors.getTicketLoaded)
      .pipe(take(1))
      .subscribe(isLoaded => {
        isLoaded
          ? null
          : this.store.dispatch(TicketActions.initTicketState({ sourceInitiator }))
      });
  }
  clearState(sourceInitiator: string): void {
    this.store.dispatch(TicketActions.clearTicketState({ sourceInitiator }));
  }

  setError(error: TError): void {
    this.store.dispatch(TicketActions.setError({ error }));
  }

  getCountersAPI(runId: string, sourceInitiator: string,): void {
    this.store.dispatch(TicketActions.getCountersAPI({
      sourceInitiator,
      runId
    }));
  }
}
